"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECT_OUTLET = void 0;
var SELECT_OUTLET = {
  TEXT__RESULT_OUTLET_NAME: 'newOrderFlow-span-resultOutletName',
  TEXT__OUTLET_NAME: 'newOrderFlow-span-outletName',
  INPUT__OUTLET_SEARCH: 'newOrderFlow-input-outletSearch',
  INPUT__ORDER_REFERENCE: 'newOrderFlow-input-orderReferenceNumber',
  BUTTON__SEARCH_RESULT: 'newOrderFlow-li-searchResult',
  BUTTON__REMOVE_OUTLET: 'newOrderFlow-button-removeOutlet'
};
exports.SELECT_OUTLET = SELECT_OUTLET;